/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const saveReviewResponseDataSchema = z.object({
  id: z.string(),
  level: z.number().int(),
  nextReviewAt: z.number().int(),
});

export type ISaveReviewResponseData = z.infer<typeof saveReviewResponseDataSchema>;

export const saveReviewResponseSchema = createApiResponseSchema(
  saveReviewResponseDataSchema,
) as z.ZodSchema<IAPI<ISaveReviewResponseData>>;

export type ISaveReviewResponse = IAPI<ISaveReviewResponseData>;
